import { getGraphqlUrl } from '../../apollo';
export function hotelSearchResultsMetric(data) {
    const { hotelCount, tripStateId } = data.hotelSearchResults || {};
    fetch(`${getGraphqlUrl()}/recordhotelsearchresults`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query: `
                mutation RecordHotelSearchResults($tripStateId: ID!, $hasNavl: Boolean!) {
                    recordHotelSearchResults(tripStateId: $tripStateId, hasNavl: $hasNavl){
                        hasNavl
                    }
                }
            `,
            variables: {
                tripStateId,
                hasNavl: hotelCount === 0,
            },
        }),
    }).catch((error) => {
        console.error('Error in hotelSearchResultsMetric', error);
    });
}
